import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';

import CloudinaryImage from '../common/CloudinaryImage';
import Container from '../common/Container';
import SubscribeMail from '../common/SubscribeMail';

export default function WriteCTA({ isContect, Pricing, setModalCall = false }) {
  return (
    <div className="py-[30px] relative">
      <Container className="relative z-[1]">
        <div className="grid grid-cols-12 rounded-[40px] md:py-8 md:px-8 py-4 px-4 flex items-center">
          <div className="text-[#fff] md:col-span-7 col-span-12">
            {Pricing?.title && (
              <h3
                className={`${Pricing?.descriptions && 'mb-4'} xl:text-[34px] md:text-[28px] text-[24px] font-[600]`}
              >
                {Pricing?.title}
              </h3>
            )}
            {Pricing?.titleEditor && (
              <ReactMarkdown
                rehypePlugins={[rehypeRaw]}
                className={`${Pricing?.titleEditor && 'mb-4'} xl:text-[34px] md:text-[28px] text-[24px] font-[600]`}
                source={Pricing?.titleEditor}
              >
                {Pricing?.titleEditor}
              </ReactMarkdown>
            )}
            {Pricing?.descriptions?.length > 0 &&
              Pricing?.descriptions?.map(des => (
                <p
                  className={`md:text-[22px] text-[14px] font-[400] mb-2`}
                  key={des?.id}
                >
                  <span className="text-[#D87BFF] font-[600] md:text-[24px] text-[16px]">
                    {des?.description_first}&nbsp;
                  </span>
                  {des?.description}
                </p>
              ))}
            {Pricing?.small_description && (
              <p className="md:text-[20px] text-[14px] font-[400]">
                {Pricing?.small_description}
              </p>
            )}
            <SubscribeMail isContect={isContect} />
            {Pricing?.btn_text && (
              <button
                className={`btnleftright relative overflow-hidden bg-[#0050D5] shadow-[0px_30px_40px_0px_#0C1A4B14] py-3 px-7 md:text-[20px] text-[14px] font-[500] ${Pricing?.btn_text && 'md:mt-10 mt-5'}`}
                onClick={() => setModalCall(Pricing?.btn_text)}
              >
                <span className="relative z-[5] transition duration-300 ease-in-out">
                  {Pricing?.btn_text}
                </span>
              </button>
            )}
          </div>
          <div className="col-span-5 md:block hidden">
            {Pricing?.image?.data?.attributes?.url && (
              <CloudinaryImage
                backendImgUrl={Pricing?.image?.data?.attributes?.url}
                alt={Pricing?.image?.data?.attributes?.alternativeText}
                className="w-full h-full object-cover mx-auto"
                type="isDesktop"
              />
            )}
          </div>
        </div>
      </Container>
      {Pricing?.bgImage?.data?.attributes?.url && (
        <CloudinaryImage
          backendImgUrl={Pricing?.bgImage?.data?.attributes?.url}
          alt={Pricing?.bgImage?.data?.attributes?.alternativeText}
          className="w-full h-full object-cover absolute top-0 bottom-0 left-0 right-0"
          type="smallimg"
        />
      )}
    </div>
  );
}
